import { type ReactNode } from 'react';

interface AuthSurfaceProps {
  label: string;
  busy?: boolean;
  children: ReactNode;
}

export const AuthSurface = ({ label, busy, children }: AuthSurfaceProps) => {
  return <section aria-label={label} aria-busy={busy || undefined} className="mx-auto w-full max-w-[32.5rem] px-4 py-8 sm:px-5 sm:py-12">
    <div className="min-w-0 space-y-6 rounded-xl border border-gray-200/80 bg-white p-6 shadow-[0_8px_32px_-16px_rgba(17,24,39,0.18)] sm:p-8">
      {children}
    </div>
  </section>;
};
